<template>
  <div>
    <Head title="Comments" />
    <h1 class="mb-8 text-3xl font-bold">Comments</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Rate:</label>
        <select v-model="form.rate" class="form-select mt-1 w-full">
          <option :value="null">All</option>
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
        </select>
      </search-filter>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">User</th>
          <th class="pb-4 pt-6 px-6">Created at</th>
          <th class="pb-4 pt-6 px-6">Recording/Photo</th>
          <th class="pb-4 pt-6 px-6">Comment</th>
          <th class="pb-4 pt-6 px-6" colspan="2">Rate</th>
        </tr>
        <tr v-for="comment in comments.data" :key="comment.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/comments/${comment.id}/edit`">
              {{ comment.user.first_name }} {{ comment.user.last_name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/comments/${comment.id}/edit`" tabindex="-1">
              {{ comment.created_at }}
            </Link>
          </td>
          <td class="border-t">
            {{ comment.recording ? comment.recording.name : (comment.photo ? comment.photo.name : '') }}
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/comments/${comment.id}/edit`" tabindex="-1">
              {{ comment.content && comment.content.length > 0 ? comment.content.slice(0, 15) + '...' : '' }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/comments/${comment.id}/edit`" tabindex="-1">
              {{ comment.rate }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/comments/${comment.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="comments.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No comments found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="comments.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    comments: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        rate: this.filters.rate,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/comments', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    openRecording(recording) {
      window.open(recording.url, '_blank')
    },
  },
}
</script>
